import {announce} from '@github-ui/aria-live'
import {Heading} from '@primer/react'
import {useEffect} from 'react'

import styles from './AIResourceSearchPage.module.css'

type SearchResultsHeaderProps = {
  query: string
  status: 'success' | 'loading' | 'empty' | 'error'
  totalCount?: number
}

export function SearchResultsHeader({query, status, totalCount}: SearchResultsHeaderProps) {
  let summary: string

  switch (status) {
    case 'success': {
      const count = totalCount ?? 0
      summary = `${count.toLocaleString('en-US')} ${count === 1 ? 'result' : 'results'} for ${query}`
      break
    }
    case 'loading':
      summary = `Loading AI resources for ${query}`
      break
    case 'empty':
      summary = `0 results for ${query}`
      break
    case 'error':
      summary = 'AI resource search unavailable'
      break
  }

  useEffect(() => {
    announce(summary)
  }, [summary])

  return (
    <div className={styles.ResultsHeader}>
      <Heading as="h2" className={styles.ResultsHeading}>
        {summary}
      </Heading>
    </div>
  )
}
